import styled from 'styled-components';

export const ComparablesContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-gap: 30px;
  grid-template-rows: 30% 70%;
`;

export const ComparablesList = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`;

export const ComparablesInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
`;

export const ComparablePrices = styled.div`
  justify-self: flex-end;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: space-between;
  column-gap: 15px;
`;
export const ComparablePricesBeaRequest = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const ComparablesDetails = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  column-gap: 15px;
`;
export const ComparableDetail = styled.div`
  display: flex;
  align-items: center;
  column-gap: 2px;
`;
export const ComparablesFeatures = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  column-gap: 8px;
`;
export const ComparablePublishingSection = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`;

type ComparablePublishingChipProps = {
  backgroundcolor: string;
  color: string;
};

export const ComparablePublishingChip = styled.div<ComparablePublishingChipProps>`
  display: flex;
  padding: 3px 8px;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.backgroundcolor};
  color: ${(props) => props.color};
  font-size: 12px;
  font-weight: 500;
`;

export const ComparableId = styled.a`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  align-self: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.color};
  text-decoration: none;
  cursor: pointer;
  
  &:hover {
    opacity: 0.8;
  }
`;
export const ComparableImage = styled.div`
  width: 120px;
  height: 90px;
  min-width: 120px;
  min-height: 90px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  img {
    width: 100%;
    height: auto;
    min-height: 100%;
    object-fit: contain;
    object-position: top center;
    border-radius: 8px;
  }
`;

export const ComparableTitle = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  column-gap: 10px;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #363c4b;
`;

export const ComparableAddress = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #363c4b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
  display: block;
`;

export const ComparableSubtypology = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #363c4b;
  white-space: nowrap;
`;
export const ComparableMainPrice = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.2;
  color: #363c4b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
`;
export const ComparablePrimaryLabel = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #363c4b;
`;
export const ComparableSecondaryLabel = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #747d93;
`;

export const FeatureSeparator = styled.div`
  width: 1px;
  height: 80%;
  background-color: #747d93;
`;
export const ComparableItem = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 30px 130px auto 15%;
  border-radius: 15px;
  padding: 10px 20px 10px 10px;
  background-color: #fafbfc;
  grid-gap: 10px;
`;